import { format, formatRelative } from "date-fns/esm";

const relativeDate = date => formatRelative(date, new Date());

const fullDate = date => format(date, "ddd, MMM Do YYYY"); // Sun, Dec 31st 1990

export { relativeDate, fullDate };



// WEBPACK FOOTER //
// ./src/util/filters.js